'use client'
import {
  ABSOLUTE_FALLBACK_CURRENCY
} from "./chunk-WFHUYKGS.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-QB4ZOYYY.mjs";

// src/context/root/context.ts
import { createContext } from "react";
var defaultState = {
  currency: ABSOLUTE_FALLBACK_CURRENCY,
  symbol: ABSOLUTE_FALLBACK_CURRENCY.symbol,
  detectedCurrency: "SAR"
};
var context_default = createContext(__spreadProps(__spreadValues({}, defaultState), {
  currencies: [],
  active: false,
  setCurrency: () => {
  },
  exchangePrice: (price, currency, format) => {
    if (format) {
      return `${price + (currency || "")}`;
    }
    return price;
  },
  unExchangePrice: (price, currency, format) => {
    if (format) {
      return `${price + (currency || "")}`;
    }
    return price;
  },
  exchangePriceForCurrency: (price, original, target, format) => __async(void 0, null, function* () {
    if (format) {
      return `${price + (original || "")}`;
    }
    return price;
  })
}));

export {
  defaultState,
  context_default
};
//# sourceMappingURL=chunk-HDMRRVS3.mjs.map